import { RadioField, RadioFieldProps } from '@cademy-ui/form';

export type CustomRadioFieldProps<Options extends string> = RadioFieldProps<Options>;

export const CustomRadioField = <Options extends string = string>(
    props: CustomRadioFieldProps<Options>
) => {
    return <RadioField {...props} />;
};
